import { RevenueReportItemDTO } from "@gymflow/types";
import { CellContext } from "@tanstack/react-table";
import { PMLinkIcon } from "apps/portal/src/components/atoms/icons/PMLinkIcon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import PMCustomAllIcon from "../../../../components/atoms/icons/PMCustomAllIcon";
import PMCustomCashIcon from "../../../../components/atoms/icons/PMCustomCashIcon";
import {
  CARD_BRAND_ICONS,
  PAYMENT_METHOD_TYPE_ICONS,
  WALLET_ICONS,
} from "../../../../components/PaymentMethodIcons";

export type PaymentMethodColumnProps = {
  row: CellContext<RevenueReportItemDTO, RevenueReportItemDTO>;
};

export const PaymentMethodColumn = ({ row }: PaymentMethodColumnProps) => {
  const { t } = useTranslation();
  const reportItem = row.getValue();
  const { icon, text } = useMemo(() => {
    return {
      CARD: {
        icon: reportItem.walletType
          ? WALLET_ICONS[reportItem.walletType]
          : CARD_BRAND_ICONS[reportItem.cardBrand ?? "unknown"],
        text: t(
          "page.reports.revenueTotal.table.paymentMethodColumn.endingIn",
          {
            last4Digits: reportItem.last4Digits,
          },
        ),
      },
      CUSTOM: {
        icon:
          reportItem.customPaymentCategoryName === "Cash" ? (
            <PMCustomCashIcon />
          ) : (
            <PMCustomAllIcon />
          ),
        text: reportItem.customPaymentCategoryName,
      },
      LINK: { icon: <PMLinkIcon />, text: reportItem.linkEmail },
      DIRECT_DEBIT: {
        icon: PAYMENT_METHOD_TYPE_ICONS[reportItem.paymentMethodType],
        text: t(
          "page.reports.revenueTotal.table.paymentMethodColumn.endingIn",
          {
            last4Digits: reportItem.last4Digits,
          },
        ),
      },
    }[reportItem.paymentType];
  }, [reportItem, t]);
  if (reportItem.transactionAmount === 0)
    return (
      <div className="flex items-center gap-x-2 text-sm font-semibold text-gray-950">
        {t("portal.common.none")}
      </div>
    );

  return (
    <div className="flex items-center gap-x-2 text-sm font-semibold text-gray-950">
      {icon}
      {text}
    </div>
  );
};
